import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import AdminNotificationsTab from './AdminNotificationsTab';

const NotificationsPage = () => {
  const { t } = useTranslation(['notifications']);

  return (
    <div className="h-full flex flex-col">
      <Typography.Paragraph type="secondary" className="mb-4 text-xs">
        {t('pageDescription')}
      </Typography.Paragraph>
      <AdminNotificationsTab />
    </div>
  );
};

export default NotificationsPage;
